import { isBrowser } from './utils';
function isDefaultPort(port, protocol) {
  switch (protocol) {
    case 'http:':
      return port === '80';
    case 'https:':
      return port === '443';
  }
  return true;
}
var RULES = [['#', 'hash'], ['?', 'query'], ['/', 'path'], ['@', 'auth', 1], [NaN, 'host', undefined, 1]];
var PROTOCOL_REGEX = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;
export var Url = function () {
  function Url(url) {
    var _this$extractProtocol = this.extractProtocol(url || ''),
      protocol = _this$extractProtocol.protocol,
      address = _this$extractProtocol.address,
      slashes = _this$extractProtocol.slashes;
    var relative = !protocol && !slashes;
    var location = this.getLocation();
    var instructions = RULES.slice();
    address = address.replace('\\', '/');
    if (!slashes) {
      instructions[2] = [NaN, 'path'];
    }
    var index;
    for (var i = 0; i < instructions.length; i++) {
      var instruction = instructions[i];
      var parse = instruction[0];
      var key = instruction[1];
      if (typeof parse === 'string') {
        index = address.indexOf(parse);
        if (~index) {
          var instLength = instruction[2];
          if (instLength) {
            var newIndex = address.lastIndexOf(parse);
            index = Math.max(index, newIndex);
            this[key] = address.slice(0, index);
            address = address.slice(index + instLength);
          } else {
            this[key] = address.slice(index);
            address = address.slice(0, index);
          }
        }
      } else {
        this[key] = address;
        address = '';
      }
      this[key] = this[key] || (relative && instruction[3] ? location[key] || '' : '');
      if (instruction[3]) this[key] = this[key].toLowerCase();
    }
    if (relative && this.path.charAt(0) !== '/') {
      this.path = '/' + this.path;
    }
    this.relative = relative;
    this.protocol = protocol || location.protocol;
    this.hostname = this.host;
    this.port = '';
    if (/:\d+$/.test(this.host)) {
      var value = this.host.split(':');
      var port = value.pop();
      var hostname = value.join(':');
      if (isDefaultPort(port, this.protocol)) {
        this.host = hostname;
      } else {
        this.port = port;
      }
      this.hostname = hostname;
    }
    this.origin = this.protocol && this.host && this.protocol !== 'file:' ? this.protocol + '/*                     */
    this.href = this.toString();
  }
  var _proto = Url.prototype;
  _proto.toString = function toString() {
    var result = this.protocol;
    result += '/**/
    if (this.auth) {
      var REDACTED = '[REDACTED]';
      var userpass = this.auth.split(':');
      var username = userpass[0] ? REDACTED : '';
      var password = userpass[1] ? ':' + REDACTED : '';
      result += username + password + '@';
    }
    result += this.host;
    result += this.path;
    result += this.query;
    result += this.hash;
    return result;
  };
  _proto.getLocation = function getLocation() {
    var globalVar = {};
    if (isBrowser) {
      globalVar = window;
    }
    return globalVar.location;
  };
  _proto.extractProtocol = function extractProtocol(url) {
    var match = PROTOCOL_REGEX.exec(url);
    return {
      protocol: match[1] ? match[1].toLowerCase() : '',
      slashes: !!match[2],
      address: match[3]
    };
  };
  return Url;
}();
export function slugifyUrl(urlStr, depth) {
  if (depth === void 0) {
    depth = 2;
  }
  var parsedUrl = new Url(urlStr);
  var query = parsedUrl.query,
    path = parsedUrl.path;
  var pathParts = path.substring(1).split('/');
  var redactString = ':id';
  var wildcard = '*';
  var specialCharsRegex = /\W|_/g;
  var digitsRegex = /[0-9]/g;
  var lowerCaseRegex = /[a-z]/g;
  var upperCaseRegex = /[A-Z]/g;
  var redactedParts = [];
  var redactedBefore = false;
  for (var index = 0; index < pathParts.length; index++) {
    var part = pathParts[index];
    if (redactedBefore || index > depth - 1) {
      if (part) {
        redactedParts.push(wildcard);
      }
      break;
    }
    var numberOfSpecialChars = (part.match(specialCharsRegex) || []).length;
    if (numberOfSpecialChars >= 2) {
      redactedParts.push(redactString);
      redactedBefore = true;
      continue;
    }
    var numberOfDigits = (part.match(digitsRegex) || []).length;
    if (numberOfDigits > 3 || part.length > 3 && numberOfDigits / part.length >= 0.3) {
      redactedParts.push(redactString);
      redactedBefore = true;
      continue;
    }
    var numberofUpperCase = (part.match(upperCaseRegex) || []).length;
    var numberofLowerCase = (part.match(lowerCaseRegex) || []).length;
    var lowerCaseRate = numberofLowerCase / part.length;
    var upperCaseRate = numberofUpperCase / part.length;
    if (part.length > 5 && (upperCaseRate > 0.3 && upperCaseRate < 0.6 || lowerCaseRate > 0.3 && lowerCaseRate < 0.6)) {
      redactedParts.push(redactString);
      redactedBefore = true;
      continue;
    }
    part && redactedParts.push(part);
  }
  var redacted = '/' + (redactedParts.length >= 2 ? redactedParts.join('/') : redactedParts.join('')) + (query ? '?{query}' : '');
  return redacted;
}